import { cn } from '@latitude/token-utils';
import * as ToastPrimitives from '@radix-ui/react-toast';
import { type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { toastVariants } from 'variants/toast-variants';

/**
 * Represents a toast component.
 *
 * @component
 * @example
 * ```tsx
 * <Toast variant="success" />
 * ```
 */
const Toast = ({
  className,
  variant,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof ToastPrimitives.Root> &
  VariantProps<typeof toastVariants> & {
    'data-testid'?: string;
  } & {
    ref?: Ref<ComponentRef<typeof ToastPrimitives.Root>>;
  }) => {
  return (
    <ToastPrimitives.Root
      ref={ref}
      data-testid={props['data-testid'] || 'toast'}
      className={cn(toastVariants({ variant }), className)}
      {...props}
    />
  );
};
Toast.displayName = ToastPrimitives.Root.displayName;

export { Toast };
